import AxiosInstance from "../config/AxiosInstance";

interface Country {
    id: string;
    code: string;
    name: string;
}

interface CountryResponse {
    success: boolean;
    data: {
        id: string;
        countryCode: string;
        countryName: string;
        faviconUrl: string | null;
        isActive: boolean;
        isDeleted: boolean;
        createdAt: string;
        updatedAt: string;
    }[];
}

export const getCountries = async (): Promise<Country[]> => {
    try {
        const response = await AxiosInstance.get<CountryResponse>('/api/web/country');
        return response.data.data.map((country: any) => ({
            id: country.id,
            code: country.countryCode,
            name: country.countryName
        }));
    } catch (error) {
        throw error;
    }
};
